import { FormControlLabel, Switch, Table, TableBody, TableCell, TableRow, Tooltip } from '@material-ui/core';
import styled from "styled-components";
import {
    WalletConnectButton as MaterialUIWalletConnectButton,
    WalletDialogButton as MaterialUIWalletDialogButton,
    WalletDialogProvider as MaterialUIWalletDialogProvider,
    WalletDisconnectButton as MaterialUIWalletDisconnectButton,
    WalletMultiButton as MaterialUIWalletMultiButton,
} from '@solana/wallet-adapter-material-ui';
import { ConnectionProvider, useLocalStorage, WalletProvider } from '@solana/wallet-adapter-react';
import {
    getBitpieWallet,
    getCoin98Wallet,
    getLedgerWallet,
    getMathWallet,
    getPhantomWallet,
    getSolflareWallet,
    getSolletWallet,
    getSolongWallet,
    getTorusWallet,
} from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import { useSnackbar } from 'notistack';
import React, { useCallback, useMemo, useEffect, useState } from 'react';
import SendTransaction from './SendTransaction';

export const Demo = () => {
    const endpoint = useMemo(() => clusterApiUrl('mainnet-beta'), []);
    // clusterApiUrl returns a string.
    
    const [autoConnect, setAutoConnect] = useLocalStorage('autoConnect', false);

    const wallets = useMemo(
        () => [
            getPhantomWallet(),
            getSolflareWallet(),
            getTorusWallet(),
            getLedgerWallet(),
            getSolongWallet(),
            getMathWallet(),
            getSolletWallet(),
            getCoin98Wallet(),
            getBitpieWallet(),
        ],
        []
    );

    const { enqueueSnackbar } = useSnackbar();
    const onError = useCallback(
        (error) => {
            enqueueSnackbar(error.message ? `${error.name}: ${error.message}` : error.name, { variant: 'error' });
            console.error(error);
        },
        [enqueueSnackbar]
    );
const MainContainer = styled.div`
  background-color: #000000;
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-right: 0%;
  margin-left: 0%;
  text-align: center;
  justify-content: center;
`;

const MintContainer = styled.div`
background-color: #000000;
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 20px;
`;

const DesContainer = styled.div`
background-color: #000000;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 20px;
`;
const Logo = styled.div`
background-color: #000000;
  flex: 0 0 auto;

  img {
    height: 60px;
  }
`;
const Menu = styled.ul`
background-color: #000000;
  list-style: none;
  display: inline-flex;
  flex: 1 0 auto;

  li {
    margin: 0 12px;

    a {
      color: var(--main-text-color);
      list-style-image: none;
      list-style-position: outside;
      list-style-type: none;
      outline: none;
      text-decoration: none;
      text-size-adjust: 100%;
      touch-action: manipulation;
      transition: color 0.3s;
      padding-bottom: 15px;

      img {
        max-height: 26px;
      }
    }

    a:hover, a:active {
      color: rgb(131, 146, 161);
      border-bottom: 4px solid var(--title-text-color);
    }

  }
`;
const ShimmerTitle = styled.h1`
background-color: #000000;
  margin: 50px auto;
  text-transform: uppercase;
  animation: glow 2s ease-in-out infinite alternate;
  color: var(--main-text-color);
  @keyframes glow {
    from {
      text-shadow: 0 0 20px var(--main-text-color);
    }
    to {
      text-shadow: 0 0 30px var(--title-text-color), 0 0 10px var(--title-text-color);
    }
  }
`;
const Image = styled.img`
background-color: #000000;
  height: 400px;
  width: auto;
  border-radius: 7px;
  box-shadow: 5px 5px 40px 5px rgba(0,0,0,0.5);
`;
const WalletContainer = styled.div`
background-color: #000000;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;
const MintButtonContainer = styled.div`
background-color: #000000;
  button.MuiButton-contained:not(.MuiButton-containedPrimary).Mui-disabled {
    color: #464646;
  }

  button.MuiButton-contained:not(.MuiButton-containedPrimary):hover,
  button.MuiButton-contained:not(.MuiButton-containedPrimary):focus {
    -webkit-animation: pulse 1s;
    animation: pulse 1s;
    box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
  }

  @-webkit-keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 #ef8f6e;
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 #ef8f6e;
    }
  }
`;
    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} onError={onError} autoConnect={autoConnect}>
                <MaterialUIWalletDialogProvider>
                   <main>
            <MainContainer>
                <WalletContainer>
                    <Logo><a href="https://flexfox.io" target="_blank" rel="noopener noreferrer"><img alt=""
                                                                                                          src="https://elonplant.com/mint/logo.png"/></a></Logo>
                    <Menu>
                        <li><a href="https://flexfox.io" target="_blank" rel="noopener noreferrer" style={{color:'#ffffff'}}>Home</a>
                        </li>
                        <li><a href="https://flexfox.io/#roadmap" target="_blank"
                               rel="noopener noreferrer" style={{color:'#ffffff'}}>Roadmap</a></li>
                        <li><a href="https://flexfox.io/#faq" target="_blank"
                               rel="noopener noreferrer" style={{color:'#ffffff'}}>FAQ</a></li>
                        <li><a href="https://twitter.com/FlexFoxNFT" target="_blank"
                               rel="noopener noreferrer" style={{color:'#ffffff'}}>Twitter</a></li>
                        <li><a href="https://discord.gg/jwDRZZSaCB" target="_blank"
                               rel="noopener noreferrer" style={{color:'#ffffff'}}>Discord</a></li>
                    </Menu>
                    </WalletContainer>
                <h1 style={{color:'#ffffff'}}>FlexFox | Public Mint</h1>
                <br/>
                <MintButtonContainer>
               
                    
                    <h2 style={{color:'#ffffff'}}>FlexFox NFT</h2>
                            <br/>
                            <div><Image
                                src="fox.gif" /></div>
                                 <br/>

                                
                                <p>
                                    <MaterialUIWalletMultiButton />
                                </p>
                                <p>
                                    <SendTransaction />
                                </p>
                                
                    
                
                </MintButtonContainer>
            </MainContainer>
             </main>
                </MaterialUIWalletDialogProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};
